import { render, staticRenderFns } from "./ResourcesPagination.vue?vue&type=template&id=d6359652"
import script from "./ResourcesPagination.vue?vue&type=script&lang=ts"
export * from "./ResourcesPagination.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports